import env from '@framework/env/env';

const searchEngineConfig = {
  allowIndexing: env('SE__ALLOW_INDEXING') === 'true',
};

export default searchEngineConfig;
